/**
 * THIS FILE IS AUTOGENERATED
 * Do not edit directly as it will be overwritten by the task that generated it
 */

import { useEffect, useState } from 'react'
import type { BrandThemeIcon } from '@jotta/types/Brand'
import { useBrandCode } from '../../hooks/useBrandTheme'

type IconLoader = () => Promise<{ default: BrandThemeIcon }>

const brandIcons: Record<string, IconLoader> = {
  ONLIME_WL: () =>
    import(
      /* webpackChunkName: "icons-onlime" */ '@jotta/design-system/icons/onlime/FillCaretDown.svg'
    ),
  ELGIGANTEN: () =>
    import(
      /* webpackChunkName: "icons-elgiganten" */ '@jotta/design-system/icons/elgiganten/FillCaretDown.svg'
    ),
  MEDIAMARKT: () =>
    import(
      /* webpackChunkName: "icons-mediamarkt" */ '@jotta/design-system/icons/mediamarkt/FillCaretDown.svg'
    ),
  PHONERO: () =>
    import(
      /* webpackChunkName: "icons-phonero" */ '@jotta/design-system/icons/phonero/FillCaretDown.svg'
    ),
  HALEBOP: () =>
    import(
      /* webpackChunkName: "icons-halebop" */ '@jotta/design-system/icons/halebop/FillCaretDown.svg'
    ),
  ELKO: () =>
    import(
      /* webpackChunkName: "icons-elko" */ '@jotta/design-system/icons/elko/FillCaretDown.svg'
    ),
  TELIA_CLOUD: () =>
    import(
      /* webpackChunkName: "icons-teliacloud" */ '@jotta/design-system/icons/teliacloud/FillCaretDown.svg'
    ),
  GIGANTTI: () =>
    import(
      /* webpackChunkName: "icons-gigantti" */ '@jotta/design-system/icons/gigantti/FillCaretDown.svg'
    ),
  LETS_GO: () =>
    import(
      /* webpackChunkName: "icons-letsgo" */ '@jotta/design-system/icons/letsgo/FillCaretDown.svg'
    ),
  OBOS: () =>
    import(
      /* webpackChunkName: "icons-obos" */ '@jotta/design-system/icons/obos/FillCaretDown.svg'
    ),
  TEST: () =>
    import(
      /* webpackChunkName: "icons-test" */ '@jotta/design-system/icons/test/FillCaretDown.svg'
    ),
  SATURN: () =>
    import(
      /* webpackChunkName: "icons-saturn" */ '@jotta/design-system/icons/saturn/FillCaretDown.svg'
    ),
  ELKJOP: () =>
    import(
      /* webpackChunkName: "icons-elkjop" */ '@jotta/design-system/icons/elkjop/FillCaretDown.svg'
    ),
  GET: () =>
    import(
      /* webpackChunkName: "icons-teliasky" */ '@jotta/design-system/icons/teliasky/FillCaretDown.svg'
    ),
  TDC_NO: () =>
    import(
      /* webpackChunkName: "icons-tsky" */ '@jotta/design-system/icons/tsky/FillCaretDown.svg'
    ),
  COMHEM: () =>
    import(
      /* webpackChunkName: "icons-tele2" */ '@jotta/design-system/icons/tele2/FillCaretDown.svg'
    ),
  JOTTACLOUD: () =>
    import(
      /* webpackChunkName: "icons-jottacloud" */ '@jotta/design-system/icons/jottacloud/FillCaretDown.svg'
    ),
}

const SvgFillCaretDown: BrandThemeIcon = props => {
  const brandCode = useBrandCode()
  const [Icon, setIcon] = useState<BrandThemeIcon | null>(null)

  useEffect(() => {
    let cancelled = false
    setIcon(null)

    const load = brandIcons[brandCode]

    load().then(icon => {
      if (cancelled) return
      setIcon(() => icon.default as BrandThemeIcon)
    })

    return () => {
      cancelled = true
    }
  }, [brandCode])

  if (!Icon) return null
  return <Icon {...props} />
}

export default SvgFillCaretDown
